export const LARGE_FONT_SIZE = 32;
export const NORMAL_FONT_SIZE = 27;
export const MEDIUM_FONT_SIZE = 20;
export const SMALL_FONT_SIZE = 14;
export const EXTRA_SMALL_FONT_SIZE = 10;
